import { render, staticRenderFns } from "./SportBetHistoryModal.vue?vue&type=template&id=1fe20cab&scoped=true"
import script from "./SportBetHistoryModal.vue?vue&type=script&lang=js"
export * from "./SportBetHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./SportBetHistoryModal.vue?vue&type=style&index=0&id=1fe20cab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe20cab",
  null
  
)

export default component.exports